var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{attrs:{"aria-label":"breadcrumb","role":"navigation"}},[_c('ol',{staticClass:"breadcrumb"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }